export const appStackedChartLegendFormatterFactory = (
  barMetadata: { property: string; label: string }[]
) => (value?: unknown) => {
  const targetProperty = barMetadata.find((x) => x.property === value);
  return targetProperty?.label ?? 'unknown';
};
